import React from 'react'
import QuarantineNotification from 'components/pages/users/quarantineNotification/QuarantineNotification'
import { QuarantineNotificationPageLoader } from 'v2/modules/usersManagement'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const QuarantineNotificationSelector = () => {
  const isRolledOut = isMyFeatureOn(FEATURES.EGD_React_QNS_Admin_Quarantine_Notification_Rollout)

  switch (true) {
    case isRolledOut: {
      return <QuarantineNotificationPageLoader />
    }
    default: {
      return <QuarantineNotification />
    }
  }
}

export default QuarantineNotificationSelector
